module.exports = __webpack_public_path__ + "img/SA-mob.06f4013a.jpg";